'use strict';
jQuery('.mobile-menu-toggle').click(function() {
  jQuery('.global-header').toggleClass('show-menu');
});
